import { Button, Column, ComboBox, DatePicker, DatePickerInput, FileUploader, FluidForm, Form, FormLabel, Grid, Header, Icon, NumberInput, Row, Select, SelectItem, TextArea, TextInput, Tile, } from "carbon-components-react";
import { Heading, Section } from "carbon-components-react/lib/components/Heading";
import FilterableMultiSelect from "carbon-components-react/lib/components/MultiSelect/FilterableMultiSelect";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createCategory } from "../../redux/actions/categoryAction";

function FaqFormPage({ isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const [formContent, setFormContent] = useState({
    "type": undefined,
    "title": undefined,
    "description": undefined,
  })

  const submitForm = (e) => {
    e.preventDefault()

    dispatch(createCategory(formContent, (_data) => {
      history.push("/faqs")
    }))
  }

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: "/" },
      { name: 'Faq', link: "/faqs" },
      { name: 'Create' }
    ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Section style={{ margin: '1rem 0 4rem 0' }}>
                <Heading >Create Policies</Heading>
                <p>Description Create Policis</p>
              </Section>
              <Form onSubmit={submitForm}>
                <Padding bottom='2rem'>
                  <Select
                    defaultValue={formContent.type}
                    invalidText="A valid value is required"
                    labelText="Status"
                    onChange={(v) => setFormContent((_state) => ({
                      ..._state,
                      type: v.target.value
                    }))}
                    light
                  >
                    <SelectItem
                      text="-- Select Policies --"
                      value=""
                      selected
                      disabled
                    />
                    <SelectItem
                      text="Privacy"
                      value="PRIVACY" />
                    <SelectItem
                      text="Cookies"
                      value="COOKIES" />
                    <SelectItem
                      text="Copyright"
                      value="COPYRIGHT" />
                  </Select>
                </Padding>
                <TextInput
                  labelText="Title"
                  value={formContent.title}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    title: v.target.value
                  }))}
                  style={{ marginBottom: '2rem' }}
                  light
                />
                <TextArea
                  labelText="Description"
                  value={formContent.description}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    description: v.target.value
                  }))}
                  light
                  style={{ marginBottom: '2rem' }}
                />
                <Padding top="1rem">
                  <Button disabled={isLoading} type="submit" kind="primary">Save</Button>
                  <Button onClick={() => history.push("/policies")} kind="secondary">Cancel</Button>
                </Padding>
              </Form>
            </Tile>
          </Column>
        </Row>
      </Grid>
    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(FaqFormPage)